import {getCurrentUser, UserModel} from "../../store/reducers/user/user.reducer";
import SiteBreadCrumb from "../../components/page-breadcrumb/page-breadcrumb.component";
import Typography from "@mui/material/Typography";
import React, {useEffect, useState} from "react";
import toast from "react-hot-toast";
import sendApiRequest, {NetworkMethods} from "../../lib/Network";
import {SettingsModel} from "../../models/globalSetting.model";
import {useNavigate} from "react-router-dom";
import AdvancedTable from "../../components/tables/advanced_table.component";
import TextSelectDropdownField from "../../components/input/text-select-dropdown-field.component";
import TextInputField from "../../components/input/text-input-field.component";
import ActionButton from "../../components/button/button.component";
import {useSelector} from "react-redux";

interface SettingsResponse
{
    pages: number;
    data: SettingsModel[];
}

function extractTypeFromString(input: string)
{
    switch (input.toUpperCase())
    {
        case "TELEPHONE": return "TELEPHONE";
        case "EMAIL": return "EMAIL";
        case "FACEBOOK": return "FACEBOOK";
        default: return "";
    }
}

export default function SettingsPage() {
    const navigate = useNavigate();

    const user = useSelector(getCurrentUser);

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [page, setPage] = useState<number>(1);
    const [maximumPage, setMaximumPage] = useState<number>(1);
    const [settings, setSettings] = useState<SettingsModel[]>([]);

    const currentUser = useSelector(getCurrentUser);

    /* data for settings */
    const [type, setType] = useState<string>("TELEPHONE");
    const [value, setValue] = useState<string>("");

    const handleTypeChange = (e: React.ChangeEvent<HTMLInputElement>) => setType(extractTypeFromString(`${e.target.value}`));
    const handleValueChange = (e: React.ChangeEvent<HTMLInputElement>) => setValue(e.target.value);

    useEffect(() => {
        getSettings();

        return () => {};
    }, []);

    const getSettings = async () => {
        try {
            setIsLoading(true);

            const response = await sendApiRequest({
                method: NetworkMethods.GET,
                endpoint: 'settings',
                headers: {
                    "x-public-key": process.env.REACT_APP_PUBLIC_REQUEST_KEY,
                },
            });

            if (!response.isSuccess)
            {
                toast.error(`Hiba a beállítások lekérdezése közben! ${response.error}`)
                return;
            }

            let settingsResponse: SettingsResponse = response.data;

            setMaximumPage(settingsResponse.pages);
            setSettings(settingsResponse.data);
            setIsLoading(false);
        } catch (error: any) {
            toast.error(`Hiba a beállítások lekérdezése közben! ${error.message}`)
        }
    }
    const onSubmit = async () => {
        try {
            const response = await sendApiRequest({
                method: NetworkMethods.POST,
                endpoint: `settings/upload`, // update?key=${type}&value=${value}
                headers: {
                    "x-public-key": process.env.REACT_APP_PUBLIC_REQUEST_KEY,
                    'Authorization': 'Bearer ' + currentUser.token
                },
                payload: {
                    key: type,
                    value
                }
            });

            if (!response.isSuccess)
            {
                toast.error(`Hiba a beállítás frissítése közben! ${response.error}`)
                return;
            }

            await getSettings();
        } catch (error: any) {
            toast.error(`Hiba a beállítás frissítése közben! ${error.message}`)
        }
    }

    if (isLoading) {
        return <div>Betöltés...</div>
    }

    return (
      <div>
        <SiteBreadCrumb
          sites={[
            {
              name: "Főoldal",
              url: "/",
            },
            {
              name: "Beállítások",
              url: "/beallitasok",
            },
          ]}
        />

        <Typography variant="h3">Beállítás varázsló</Typography>
        <br />
        <br />
        <br />
        <Typography variant="h3">Beállítás módosítás</Typography>
        <br />
        <TextSelectDropdownField
          data={["TELEPHONE", "EMAIL", "FACEBOOK"].map((x) => ({
            title: x,
            value: x,
          }))}
          value={type}
          title="Típus kiválasztása"
          onChange={handleTypeChange}
          defaultValue={"TELEPHONE"}
        />
        <TextInputField
          title={"Érték"}
          value={value}
          onChange={handleValueChange}
          fullWidth
        />
        <br />
        <ActionButton
          title="Beállítás frissítése"
          type={"ADD"}
          action={onSubmit}
        />
        <br />
        <br />
        <Typography variant="h3">Elérhető beállítások</Typography>
        <br />
        <AdvancedTable
          columns={["ID", "Kategória", "Tartalom"]}
          rows={settings.map((setting) => ({
            id: setting.id,
            type: setting.type,
            content: setting.value,
          }))}
          properties={{
            page: page,
            pages: maximumPage,
            rowsPerPage: 10,
            totalRows: maximumPage * 10,
            disableSee: true,
            disableEdit: true,
            disableDelete: true,
          }}
          rowActions={{
            deleteAction: (row: any) => {},
            editAction: () => {},
            seeAction: (row: any) => {},
          }}
          pageChange={() => {}}
        />
      </div>
    );
}